import {ProductPromotion as TProductPromotion} from 'coreStore/data/products/types';

/**
 * Represents ProductPromotionModel
 */
class ProductPromotionModel {
	productPromotion: TProductPromotion;

	/**
	 * @constructor
	 * @param {TProductPromotion} productPromotion - product promotion
	 */
	constructor(productPromotion: TProductPromotion) {
		this.productPromotion = productPromotion;

		return {
			...this.productPromotion,
			getPromotionId: this.getPromotionId.bind(this),
			getCalloutMsg: this.getCalloutMsg.bind(this),
			getPromotionalPrice: this.getPromotionalPrice.bind(this),
		} as unknown as ProductPromotionModel;
	}

	/**
	 * Returns promotion id
	 * @returns {string} promotionId
	 */
	getPromotionId() {
		return this.productPromotion?.promotionId;
	}

	/**
	 * Returns promotion calloutMsg
	 * @returns {string} calloutMsg
	 */
	getCalloutMsg() {
		return this.productPromotion?.calloutMsg;
	}

	/**
	 * Returns promotionalPrice
	 * @returns {number} promotionalPrice
	 */
	getPromotionalPrice() {
		return this.productPromotion?.promotionalPrice;
	}
}

export default ProductPromotionModel;
